"use client";
import { Loader2Icon } from "lucide-react";
import type { ComponentPropsWithRef } from "react";
import { cn } from "@/lib/utils";
import { Button, type ButtonProps } from "@/ui/shadcn/button";

export const PendingButton = ({
	children,
	disabled,
	pending,
	ref,
	className,
	...props
}: ButtonProps & { pending?: boolean } & ComponentPropsWithRef<typeof Button>) => {
	return (
		<Button {...props} className={cn("relative", className)} disabled={pending || disabled} ref={ref}>
			<span className="contents">
				<span className={cn("transition-opacity ease-in", pending ? "opacity-0" : "opacity-100")}>
					{children}
				</span>
				<span
					className={cn(
						"ease-out transition-opacity pointer-events-none absolute z-10",
						pending ? "opacity-100" : "opacity-0",
					)}
				>
					<Loader2Icon className="absolute left-[calc(50%-0.5rem)] top-[calc(50%-0.5rem)] h-4 w-4 animate-spin" />
				</span>
			</span>
		</Button>
	);
};
